export default "__VITE_ASSET__CdQ04_fv__"